export const roundToZero = (num: number) => {
  return Math.round(num);
};

export const roundToOne = (num: number) => {
  return Math.round((num + Number.EPSILON) * 10) / 10;
};

export const roundToTwo = (num: number) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const roundToThree = (num: number) => {
  return Math.round((num + Number.EPSILON) * 1000) / 1000;
};

export const toPercentage = ({
  value,
  callback = roundToTwo
}: {
  value?: unknown;
  callback?: (num: number) => number;
}) => {
  let num = toNumber({ value: value });
  if (num !== undefined) {
    num = num * 100;
    return callback ? callback(num) : num;
  }
};

export const formatPercentage = ({ val, defValue = '' }: { val?: unknown; defValue?: string }) => {
  if (val == undefined) return defValue;
  return `${val}%`;
};

export const toPercentageFormat = ({
  value,
  callback = roundToTwo,
  defValue = ''
}: {
  value?: unknown;
  callback?: (num: number) => number;
  defValue?: string;
}) => {
  const num = toPercentage({ value: value, callback: callback });
  return formatPercentage({ val: num, defValue: defValue });
};

export const formatPremium = ({ value, defValue = '' }: { value?: unknown; defValue?: string }) => {
  const num = toNumber({ value: value });
  if (num == undefined) return defValue;
  return num > 0 ? `+${num}%` : `${num}%`;
};

export const toPremiumFormat = ({
  value,
  callback = roundToTwo,
  defValue = ''
}: {
  value?: unknown;
  callback?: (num: number) => number;
  defValue?: string;
}) => {
  const num = toPercentage({ value: value, callback: callback });
  return formatPremium({ value: num, defValue: defValue });
};

export const toPercentageFixedFormat = ({
  value,
  callback = roundToTwo,
  digits = 2,
  defValue = ''
}: {
  value?: unknown;
  callback?: (num: number) => number;
  digits?: number;
  defValue?: string;
}) => {
  const num = toPercentage({ value: value, callback: callback });
  return formatPercentage({ val: num && num.toFixed(digits), defValue: defValue });
};

export const formatNumber = ({
  value,
  callback = roundToTwo
}: {
  value?: unknown;
  callback?: (num: number) => number;
}) => {
  if (value == undefined) return '';
  const num = toNumber({ value: value });
  return callback ? callback(num).toLocaleString() : roundToTwo(num).toLocaleString();
};

export const toNumber = ({ value, defVal = 0 }: { value: unknown; defVal?: number }) => {
  const num = Number(value);
  return !isNaN(num) ? num : defVal;
};
